import React, { useEffect, useState } from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { ProductRetouchingModal } from './index';

type OpenParams = Omit<React.ComponentProps<typeof ProductRetouchingModal>, 'show'>;

export class ProductRetouchingSDK {
    private static container: HTMLDivElement | null = null;
    private static root: Root | null = null;

    static open(params: OpenParams) {
        if (this.container) return; // 防止重复打开

        this.container = document.createElement('div');
        document.body.appendChild(this.container);

        const Wrapper: React.FC = () => {
            const [visible, setVisible] = useState(true);

            useEffect(() => {
                return () => {
                    ProductRetouchingSDK.destroy();
                };
            }, []);

            const handleClose = () => {
                setVisible(false);
                params.onClose();
            };

            return (
                <ProductRetouchingModal
                    {...params}
                    show={visible}
                    onClose={handleClose}
                    onModalClose={() => {
                        ProductRetouchingSDK.destroy();
                    }}
                />
            );
        };

        this.root = createRoot(this.container);
        this.root.render(<Wrapper />);
    }

    private static destroy() {
        if (this.container) {
            this.root?.unmount();
            this.root = null;
            document.body.removeChild(this.container);
            this.container = null;
        }
    }
}
